var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`d-flex align-center ${_vm.containerClasses}`},[_c('div',{staticClass:"d-flex align-center"},[_vm._t("iconSlot")],2),_c('div',[_vm._v(_vm._s(_vm.description))]),_c('div',[_vm._t("actionSlot")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }